import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'plural'
})
export class PluralPipe implements PipeTransform {

  transform(single_word: string = ''): string {
    if (!single_word) return '';

    if (single_word.endsWith('y') && !/[aeiou]y$/.test(single_word)) {
      return single_word.slice(0, -1) + 'ies';
    }

    if (/(s|x|sh|ch)$/.test(single_word)) {
      return single_word + 'es';
    }

    return single_word + 's';
  }
}
